import React from 'react'
import Translations from '@helpers/translations'
import { SHIPPING_FEES } from '@consts/index'
import styles from './styles.module.scss'

function SweetenersList() {
  return (
    <p className={styles.sweetenersList}>
      {Translations.localise('common.sweetenersList.option-1')}{' '}
      {SHIPPING_FEES.threshold[process.env.SHOP_LOCALE].cost} |{' '}
      {Translations.localise('common.sweetenersList.option-3')}
    </p>
  )
}

export default SweetenersList
